import { Injectable, Signal, computed, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class GoLiveService {
    private readonly registry = signal<Record<string, Date>>({});

    register(key: string, launchDate: Date): void {
        this.registry.update(r => ({ ...r, [key]: launchDate }));
    }

    isLive(key: string): Signal<boolean> {
        return computed(() => {
            const date = this.registry()[key];
            return date ? new Date() >= date : false;
        });
    }
}